<fuse-widget  class="widget p-0 h-100-p" fxLayout="column">

    <!-- Front -->
    <div class="fuse-widget-front mat-white-bg mat-elevation-z2" fxLayout="column" fxLayoutAlign="stretch stretch">

        <mat-toolbar class="px-16 py-12 border-bottom mat-accent-bg title-bar" fxLayout="row" fxLayoutAlign="space-between center">
            <div fxLayout="row" fxLayoutAlign="start center">
                <div class="h3 title pr-4" [title]="titleTooltip">{{title}}</div>
            </div>
            <div class="actions" fxLayout="row" fxLayoutAlign="start center">

                <mat-divider class='style-fix' [vertical]="true"></mat-divider>

                <button id="TaskSortOrderButton" mat-icon-button class="mat-icon-button" [matMenuTriggerFor]="mnuSortOrder" attr.aria-label="{{this.getSortOrderTooltip()}}" matTooltip="{{this.getSortOrderTooltip()}}">
                    <mat-icon  class='mat-accent-bg'>sort</mat-icon>                    
                </button>
                <mat-menu #mnuSortOrder="matMenu">
                    <button mat-menu-item *ngFor="let order of this.taskService.getSortOrders()" (click)="btnApplySortOrder(order)">
                            <mat-icon *ngIf="order.selected && order.order!==1">arrow_drop_down</mat-icon>
                            <mat-icon *ngIf="order.selected && order.order===1">arrow_drop_up</mat-icon>
                            <mat-icon *ngIf="!order.selected"></mat-icon>
                            <span>&nbsp;{{order.title}}</span>
                        </button>
                </mat-menu>

                <mat-divider class='style-fix' [vertical]="true"></mat-divider>

                <button id="TaskFilterButton" mat-icon-button class="mat-icon-button" [matMenuTriggerFor]="mnuFilter" attr.aria-label="{{this.getFilterTooltip()}}" matTooltip="{{this.getFilterTooltip()}}">
                    <mat-icon  class='mat-accent-bg'>filter_list</mat-icon>                        
                </button>
                <mat-menu #mnuFilter="matMenu">
                    <button mat-menu-item *ngFor="let filter of this.taskService.getFilters()" (click)="btnApplyFilter(filter)">
                            <mat-icon>{{filter.icon}}</mat-icon>
                            {{filter.title}}&nbsp;
                            <mat-icon *ngIf='filter.selected'>done</mat-icon>
                        </button>
                </mat-menu>

                <mat-divider *ngIf="allowEdit && allowAdd && hasSubjectUserEditPrivs" class='style-fix' [vertical]="true"></mat-divider>
                <button *ngIf="allowEdit && allowAdd && hasSubjectUserEditPrivs" #addtaskbutton mat-icon-button class="mat-icon-button" [disabled]="!allowEdit || !hasSubjectUserEditPrivs" fxFlex (click)="addtaskbutton._elementRef.nativeElement.blur();add();" aria-label="Add Task" matTooltip="Add Task">
                    <mat-icon class='mat-accent-bg'>add</mat-icon>
                </button>
            </div>
        </mat-toolbar>

        <div class="tasklist" fxLayout="row" *ngIf="!displayPage">
            <fuse-task-list fxFlex [taskSelection]='5' inWidget=true [parent]="parent" [readOnly]="userReadOnly || !hasSubjectUserEditPrivs"></fuse-task-list>
        </div>
        <div class="tasklist" fxLayout="row" *ngIf="displayPage">
            <fuse-task-details fxFlex inWidget=true></fuse-task-details>
        </div>
    </div>
    <!-- / Front -->
</fuse-widget>